import React, {Component} from 'react';
import LoginComponent from './Login';
import {Menu} from 'semantic-ui-react'

class MainMenu extends Component {

  constructor(props) {
    super(props);
    this.state = {
      activeItem: 'home',
      username: null,
      userpassword: null,
      User: null
    };
  }

  componentDidMount() {

  }

  render() {
    const {activeItem} = this.state
    return (
      <div>
        <LoginComponent handleClick={this.handleClick.bind(this)} />
        <Menu vertical inverted>
          <Menu.Item name='home' active={activeItem === 'home'} onClick={this.handleItemClick}>
            Home
          </Menu.Item>
          <Menu.Item>
            <Menu.Header>ACRIS</Menu.Header>
            <Menu.Menu>
              <Menu.Item name='submit_designations'
                         active={activeItem === 'submit_designations'}
                         onClick={this.handleItemClick}>
                Create New Submission
              </Menu.Item>
              <Menu.Item name='review_submissions'
                         active={activeItem === 'review_submissions'}
                         onClick={this.handleItemClick}>
                Review submissions
              </Menu.Item>
            </Menu.Menu>
          </Menu.Item>
        </Menu>
      </div>
    )
      // <Menu.Item name='admin' active={activeItem === 'admin'} onClick={this.handleItemClick}>
      //   Administration
      // </Menu.Item>
  }
  handleClick (data) {
    this.setState({User : data})
  }

  handleItemClick = (e, {name}) => {
    if (this.state.User === null)
      alert("Please enter user credentials before proceeding. Thanks.")
    else {
      this.props.handleClick([name, this.state.User]);
    }
  }
}

export default MainMenu



// WEBPACK FOOTER //
// ./src/components/MainMenu.js